import { render, staticRenderFns } from "./CustomerShowTreatment.vue?vue&type=template&id=f6ebe8f6&scoped=true"
import script from "./CustomerShowTreatment.vue?vue&type=script&lang=js"
export * from "./CustomerShowTreatment.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowTreatment.vue?vue&type=style&index=0&id=f6ebe8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ebe8f6",
  null
  
)

export default component.exports